import { ERROR_FIRE_ACTION } from 'store/error/actions';
import { selectErrorOnClear } from 'store/error/selectors';
import { put, select, takeEvery } from 'typed-redux-saga';

function* errorFireAction(): Generator {
  const errorAction = yield* select(selectErrorOnClear);

  if (errorAction) {
    yield put({
      payload: errorAction.payload,
      type: errorAction.type,
    });
  }
}

export const errorSideEffects = [
  takeEvery([ERROR_FIRE_ACTION], errorFireAction),
];
